module.exports = __webpack_public_path__ + "img/2.4b96dd0b.png";